
// Utility functions for candidate status

export const getStatusColor = (status: string): string => {
  const lowerStatus = status?.toLowerCase() || 'default';

  if (lowerStatus.includes('new') || lowerStatus.includes('applied')) return 'bg-blue-100 text-blue-700';
  if (lowerStatus.includes('screening') || lowerStatus.includes('assessment')) return 'bg-yellow-100 text-yellow-700';
  if (lowerStatus.includes('interview')) return 'bg-purple-100 text-purple-700';
  if (lowerStatus.includes('offer')) return 'bg-green-100 text-green-700';
  if (lowerStatus.includes('hired')) return 'bg-teal-100 text-teal-700';
  if (lowerStatus.includes('rejected') || lowerStatus.includes('declined') || lowerStatus.includes('withdrawn')) return 'bg-red-100 text-red-700';
  if (lowerStatus.includes('on hold')) return 'bg-orange-100 text-orange-700';
  
  return 'bg-gray-100 text-gray-700'; // Default color
};

export const statusOptions = [
  { value: 'new', label: 'New' },
  { value: 'applied', label: 'Applied' },
  { value: 'screening', label: 'Screening' },
  { value: 'assessment', label: 'Assessment' },
  { value: 'interviewing', label: 'Interviewing' },
  { value: 'offered', label: 'Offered' },
  { value: 'hired', label: 'Hired' },
  { value: 'rejected', label: 'Rejected' },
  { value: 'withdrawn', label: 'Withdrawn' },
  { value: 'on_hold', label: 'On Hold' }, // Ensure consistency if db uses on_hold
];

// Add other status-related utility functions if needed
